import React, { useEffect, useState } from 'react';
import {
    TextField, FormControl, InputLabel, Grid, Paper,
    useMediaQuery, Button, FormHelperText, Table, TableBody, TableCell, TableContainer,
    TableHead, TableRow, Radio, RadioGroup, FormControlLabel,
    CircularProgress
} from '@mui/material';

import Titlebar from '../TitleBar';
import { PrintingMaster } from '../TitleList';
import styled, { cutDates, inputStyles } from '../../Utils/inputChanges';
import { useDispatch, useSelector } from 'react-redux';
import { getCurrentDate } from '../../Utils/Dateutils';

import { selectParty, selectItems } from '../Selectors/Master/ItemSelectors';
import { fetchPartyData } from '../../Store/PHPSlice/Party';
import { fetchItemData } from '../../Store/PHPSlice/Item';
import DropdownWithBtn from '../FieldsComponents/DropdownWithBtn';

import { fetchPrintOutNo, InsertPrintingEntry } from '../../Store/PHPSlice/Printing';



const PrintingOutwardEntry = () => {

    const userdata = JSON.parse(localStorage.getItem('user'));

    const [formData, setFormData] = useState({
        dt: getCurrentDate(),
        printoutNo: "",
        partyId: "",
        itemId: "",
        printingMatter: "",
        printQty: "",
        deliveryPerson: "",
        receivedPerson: "",
        printSides: "oneSide",
        userId: userdata?.ID
    });

    const [loading, setLoading] = useState(false);

    const dispatch = useDispatch();
    const isDesktop = useMediaQuery('(min-width:768px)');

    const partylist = useSelector(selectParty);
    const itemlist = useSelector(selectItems);

    // ✅ Fetch printout number from Redux slice
    const printoutNoState = useSelector((state) => state.PrintingData.printoutNo);
    console.log("printoutno=>", printoutNoState);

    // -----------------------------------------
    // FETCH DROPDOWN DATA & PRINT OUT NUMBER
    // -----------------------------------------
    useEffect(() => {
        dispatch(fetchPartyData());
        dispatch(fetchItemData());
        dispatch(fetchPrintOutNo());
    }, [dispatch]);

    // -----------------------------------------
    // SET PRINT OUT NUMBER INTO FORM
    // -----------------------------------------
    // useEffect(() => {
    //     if (printoutNoState?.data?.poutno) {
    //         setFormData((prev) => ({
    //             ...prev,
    //             printoutNo: printoutNoState.data.poutno
    //         }));
    //     }
    // }, [printoutNoState]);
    useEffect(() => {
        if (printoutNoState?.data?.length > 0) {
            setFormData(prev => ({
                ...prev,
                printoutNo: printoutNoState.data[0].printoutno
            }));
        }
    }, [printoutNoState]);


    // -----------------------------------------
    // INPUT CHANGE HANDLER
    // -----------------------------------------
    const handleInputChange = (e) => {
        const { name, value } = e.target;

        // Don't convert radio values to uppercase
        if (name === "printSides") {
            setFormData({ ...formData, [name]: value });
            return;
        }

        setFormData({ ...formData, [name]: value.toUpperCase() });
    };
    const handleDateChange = (e) => {
        setFormData({
            ...formData,
            dt: e.target.value
        });
    };
    // -----------------------------------------
    // DROPDOWN HANDLER
    // -----------------------------------------
    const handleDropdownChange = (e, fieldName) => {
        const { value } = e.target;
        setFormData((prev) => ({ ...prev, [fieldName]: value }));
    };

    // -----------------------------------------
    // DROPDOWN LIST
    // -----------------------------------------
    const dropdownList = [
        {
            label: 'Party Name',
            id: 'partyId',
            options: partylist?.data,
            value: formData.partyId,
            onChange: (newValue) =>
                handleDropdownChange({ target: { name: 'partyId', value: newValue ? newValue.ID : '' } }, 'partyId'),
            getOptionLabel: (option) => option.partyNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value,
            valueFinder: (options, value) => options?.find(i => i.ID === value) || null,
            handleAddNew: () =>
                window.open(`/NewPartyEntry`, '_blank', 'width=800,height=600'),
            btnlabel: 'New'
        },
        {
            label: 'Item',
            id: 'itemId',
            options: itemlist?.data,
            value: formData.itemId,
            onChange: (newValue) =>
                handleDropdownChange({ target: { name: 'itemId', value: newValue ? newValue.ID : '' } }, 'itemId'),
            getOptionLabel: (option) => option.itemNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value,
            valueFinder: (options, value) => options?.find(i => i.ID === value) || null,
            handleAddNew: () =>
                window.open(`/NewItemEntry`, '_blank', 'width=800,height=600'),
            btnlabel: 'New'
        }
    ];

    // -----------------------------------------
    // SUBMIT
    // -----------------------------------------
    const handleSubmit = async (e) => {
        e.preventDefault();


        if (!formData.partyId) {
            alert("Select Party");
        }
        else if (!formData.itemId) {
            alert("Select Item Name");
        }
        else if (!formData.printingMatter.trim()) {
            alert("Enter Printing Matter");
        }
        else if (!formData.printQty.trim()) {
            alert("Enter Printing Qty");
        }
        else {

            setLoading(true);
            try {
                const result = await dispatch(InsertPrintingEntry(formData)).unwrap();
                // console.log('POST request successful!', result);
                alert("Printing Outward Details Submitted successfully");
                window.location.reload();
            } catch (error) {
                console.error('Error while making POST request:', error);
            } finally {
                setLoading(false);
            }
        }


    };

    return (
        <>
            <Titlebar data={PrintingMaster} />

            <div style={{ margin: '1% 0.5%' }}>
                <h2>Printing Outward Entry</h2>

                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '2vh' }}>
                            <Grid container spacing={1}>

                                {/* ----------------- DATE & PRINT OUT NO ------------------ */}
                                {[
                                    { label: 'Date', name: 'dt', type: 'date' },
                                    { label: 'Print Out No', name: 'printoutNo' }
                                ].map((field, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel>{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    {field.type === 'date' ? (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            type="date"
                                                            value={formData[field.name]}
                                                            onChange={handleDateChange}
                                                            inputProps={{ style: styled.cutDate }}
                                                            sx={cutDates}
                                                        />
                                                    ) : (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            value={formData[field.name]}
                                                            sx={inputStyles}
                                                            inputProps={{
                                                                style: styled.input,
                                                                readOnly: field.name === "printoutNo" // 🔥 MAKE READONLY
                                                            }}
                                                        />
                                                    )}
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}

                                {/* ----------------- PARTY & ITEM ------------------ */}
                                {dropdownList.map((drop) => (
                                    <DropdownWithBtn key={drop.id} {...drop} isDesktop={isDesktop} />
                                ))}

                                {/* ----------------- OTHER INPUTS ------------------ */}
                                {[
                                    { label: 'Printing Matter', name: 'printingMatter' },
                                    { label: 'Print Qty', name: 'printQty' },
                                    { label: 'Delivery Person', name: 'deliveryPerson' },
                                    { label: 'Received Person', name: 'receivedPerson' }
                                ].map((field) => (
                                    <Grid item xs={12} md={6} key={field.name}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel>{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    <TextField
                                                        name={field.name}
                                                        value={formData[field.name]}
                                                        onChange={handleInputChange}
                                                        sx={inputStyles}
                                                        inputProps={{ style: styled.input }}
                                                    />
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}

                                {/* ----------------- RADIO BUTTON ------------------ */}
                                <Grid item xs={12} md={6}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                            <InputLabel>Print Sides:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth>
                                                <RadioGroup
                                                    name="printSides"
                                                    value={formData.printSides}
                                                    onChange={handleInputChange}
                                                    row
                                                >
                                                    <FormControlLabel value="oneSide" control={<Radio />} label="One Side" />
                                                    <FormControlLabel value="bothSides" control={<Radio />} label="Both Sides" />
                                                </RadioGroup>
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                {/* ----------------- SUBMIT ------------------ */}
                                <Grid item xs={12} textAlign="center">
                                    <Button variant="contained" color="primary" onClick={handleSubmit} disabled={loading === true}>
                                        {
                                            loading === true ?
                                                <><CircularProgress size="20px" /> wait...</> :
                                                "Submit"
                                        }
                                    </Button>
                                </Grid>


                            </Grid>
                        </Paper>
                    </Grid>
                </Grid>
            </div>
        </>
    );
};

export default PrintingOutwardEntry;
